<template>
    <div class="user_bank border p-2 mr-">
        <div class="d-flex justify-content-center mb-3 mt-3 pt-3 pb-3" v-if="is_load">
            <b-spinner variant="success" label="Loading..."></b-spinner>
        </div>

        <div class="chart" v-else>
            <highcharts :options="chartOptions" :highcharts="char3d" ></highcharts>
        </div>
    </div>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts3D from 'highcharts/highcharts-3d'
    import Highcharts from 'highcharts'

    Highcharts3D(Highcharts)
    export default {
        name: "source_env",
        props: {
            id: {
                type: Number,
                require: false,
            },

            d_type : {
                type: String,
                default:"source"
            },

            month: {
                type: String,
                default:""
            },

        },

        components: {
            highcharts: Chart
        },


        mounted() {
            this.getStat();
        },
        created () {
            EventBus.$on('change_date',res => {
                this.getStat();
            }) ;
        },
        data() {
            let self = this;

            return {
                is_load: true,
                char3d : Highcharts,


                char_title : "OOPS",
                cur_type : this.d_type,

                chartOptions: {
                    chart: {
                        type: 'pie',
                        options3d: {
                            enabled: false,
                            alpha: 45
                        },
                        /*plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,*/
                    },
                    tooltip: {
                        pointFormat: "{point.y:,.1f} %"
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                format: '{point.percentage:.1f} %'
                            },
                            showInLegend: true,
                            innerSize: 100,
                            depth: 55
                        }
                    },
                    title:
                        {
                            text: "ddd",
                            style:
                                {
                                    color: '#000000',
                                    fontSize: '16px',
                                }
                            //x: -20 //center
                        },
                    series: [{
                        data: []
                    }],
                    credits: {
                        enabled: false
                    },
                },

            }
        },


        methods: {

            getTitle() {
                if(this.cur_type == 'source') {
                    return "Источник Заказов";
                }
                if(this.cur_type == 'action') {
                    return "Акции";
                }
                return "OOPS";
            },


            async getStat() {
                this.is_load = true;
                await api.post('/internal/user/dashboard/source', qs.stringify({
                        'date' : this.dash_param_date,
                        'cur_type' : this.d_type,
                    })
                ).then(({data}) => {

                    this.chartOptions.title.text = this.getTitle();


                    if (data.status == "operation_success") {
                       this.chartOptions.series = data.message.series;
                        this.is_load = false;
                    }
                    else {

                    }

                }).catch(err => {
                    this.is_load = true;
                    console.log(err);
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            },

        },
        computed: {

            dash_param() {
                return this.$store.state.dashboard.main;
            },
            dash_param_date() {
                return this.$store.state.dashboard.main.date;
            },

        },
    }
</script>

<style scoped>

</style>
